/**
 * Karekod geçmişi ekranının veri tipleri.
 * Sunucudaki KarekodGecmisi.cs ile birebir eşleşir; metinler sunucuda Türkçeleştirilir,
 * ekran yalnızca gösterir.
 */

/** Zaman çizelgesindeki bir satırın rengi. */
export type OlayRengi = 'basarili' | 'uyari' | 'hata' | 'bilgi'

/** Çizelgedeki ok yönü. */
export type OlayYonu = 'giris' | 'cikis' | 'notr'

/** Verinin geldiği defter. */
export type OlayKaynagi = 'stok' | 'alis' | 'its' | 'its-stok'

export interface KarekodOlayAlani {
  etiket: string
  deger: string
}

export interface KarekodZamanCizelgesiSatiri {
  kaynak: OlayKaynagi | string
  zaman: string
  baslik: string
  aciklama: string | null
  yon: OlayYonu | string
  renk: OlayRengi | string
  kullanici: string | null
  alanlar: KarekodOlayAlani[]
  baglantiTuru: string | null
  baglantiId: string | null
  baglantiEtiketi: string | null
}

export interface KarekodKutuKarti {
  urunId: string | null
  urunAdi: string | null
  barkod: string | null
  partiNo: string | null
  skt: string | null
  durum: string | null
  durumMetni: string | null
  girisTarihi: string | null
  girisKaynagi: string | null
  cikisTarihi: string | null
  cikisHedefi: string | null
  alisFiyati: number | null
  sktGecmis: boolean
  /** Kutunun geldiği deponun görünen adı. */
  girisDepoAdi: string | null
  girisDepoId: string | null
  /** Faturayı kesen şubenin GLN'i; ekranda gösterilmez, iade bu adrese yapılır. */
  girisGln: string | null
  girisFaturaId: string | null
  girisFaturaNo: string | null
}

export interface KarekodGecmisOzeti {
  toplamOlay: number
  girisSayisi: number
  cikisSayisi: number
  itsSorgusu: number
  ilkGorulme: string | null
  sonHareket: string | null
  rafOmruGun: number | null
  kayitYok: boolean
}

export interface KarekodGecmisiYaniti {
  seriNo: string
  gtin: string | null
  kutu: KarekodKutuKarti | null
  olaylar: KarekodZamanCizelgesiSatiri[]
  ozet: KarekodGecmisOzeti
}

const tarihSaatBicimi = new Intl.DateTimeFormat('tr-TR', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

const gunBicimi = new Intl.DateTimeFormat('tr-TR', {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
})

const saatBicimi = new Intl.DateTimeFormat('tr-TR', { hour: '2-digit', minute: '2-digit' })
const saatSaniyeBicimi = new Intl.DateTimeFormat('tr-TR', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
})

export function tarihSaatMetni(iso: string | null | undefined): string {
  if (!iso) return '—'
  const zaman = new Date(iso)
  return Number.isNaN(zaman.getTime()) ? '—' : tarihSaatBicimi.format(zaman)
}

export function gunMetni(iso: string): string {
  const zaman = new Date(iso)
  return Number.isNaN(zaman.getTime()) ? iso : gunBicimi.format(zaman)
}

export function saatMetni(iso: string): string {
  const zaman = new Date(iso)
  return Number.isNaN(zaman.getTime()) ? '' : saatBicimi.format(zaman)
}

export function saatSaniyeMetni(iso: string): string {
  const zaman = new Date(iso)
  return Number.isNaN(zaman.getTime()) ? '' : saatSaniyeBicimi.format(zaman)
}

/** Aynı güne düşen olaylar tek başlık altında toplanır; çizelge takvim gibi okunur. */
export function gunlereBol(
  olaylar: KarekodZamanCizelgesiSatiri[]
): { gun: string; satirlar: KarekodZamanCizelgesiSatiri[] }[] {
  const gruplar: { gun: string; satirlar: KarekodZamanCizelgesiSatiri[] }[] = []

  for (const olay of olaylar) {
    const gun = gunMetni(olay.zaman)
    const sonuncu = gruplar[gruplar.length - 1]
    if (sonuncu && sonuncu.gun === gun) sonuncu.satirlar.push(olay)
    else gruplar.push({ gun, satirlar: [olay] })
  }

  return gruplar
}
